/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
// import { Link } from 'react-router-dom';
// import * as ROUTES from '../constants/routes';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.css';


import {
  FaFacebookSquare,
  FaTwitter,
  FaLinkedin,
  FaInstagram
} from 'react-icons/fa';
import { Row, Col } from 'react-bootstrap';

const footerCss = {
  link: css({
    textDecoration: 'none !important',
    color: '#212529'
  }),
  footerLogo: css({
    height: '1.2rem',
    width: '2rem',
    marginBottom: '0.2rem'
  }),
  footerLogoText: css({
    color: '#00A69C',
    paddingLeft: '0.4rem',
    marginLeft: '-1rem'
  }),
  copyrightArea: css({
    minHeight: '20px',
    backgroundColor: 'black',
    color: '#fff',
    padding: '1rem'
  }),
  footerQuickLinks: css({
    marginRight: '1rem'
  }),
  footerSpacer: css({
    marginLeft: '1rem'
  })
};

const Footer = () => (
  <div className="site-footer">
    <Container className="footer-inner">
      <Row className="d-block d-md-flex p-3 align-items-center">
        <Col md={4}>
          <h5>
            <div css={footerCss.link}>
              <img
                alt=""
                css={footerCss.footerLogo}
                src={`${process.env.PUBLIC_URL}/logo192.png`}
              />
              <span css={footerCss.footerLogoText}>Renstia UG LTD</span>
            </div>
          </h5>
        </Col>
        <Col
          md={5}
          className="d-flex flex-wrap justify-content-start justify-content-md-center align-items-center footer-link-strip"
        >
          <div css={footerCss.footerQuickLinks}>
            <a css={footerCss.link} href="#hero" className="d-flex">
              Home{' '}
              <span css={footerCss.footerSpacer} className="footer-dashes d-md-inline">|</span>
            </a>
          </div>
          <div css={footerCss.footerQuickLinks}>
            <a href="#services" css={footerCss.link} className="d-flex">
              Services{' '}
              <span css={footerCss.footerSpacer} className="footer-dashes d-md-inline">|</span>
            </a>
          </div>
          <div css={footerCss.footerQuickLinks}>
            <a href="#products" css={footerCss.link} className="d-flex">
              Products{' '}
              <span css={footerCss.footerSpacer} className="footer-dashes d-md-inline">|</span>
            </a>
          </div>
          <div css={footerCss.footerQuickLinks}>
            <a href="#about" css={footerCss.link} className="d-flex">
              About{' '}
              <span css={footerCss.footerSpacer} className="footer-dashes d-md-inline">|</span>
            </a>
          </div>
          <div css={footerCss.footerQuickLinks}>
            <a href='#contact' css={footerCss.link} className="d-flex">
              Contact
            </a>
          </div>
        </Col>
        <Col className="footer-contact-col">
          renstia.finance@gmail.com +256778072363
        </Col>
      </Row>
    </Container>
    <div
      className="d-block d-md-flex align-items-center"
      css={footerCss.copyrightArea}
    >
      <Container>
        <Row className="d-block d-md-flex">
          <Col>
            &copy;
            {` ${new Date().getFullYear()} renstia ug ltd. All rights reserved.`}
          </Col>
          <Col className="d-flex justify-content-start justify-content-md-end">
            <div css={footerCss.footerQuickLinks}>
              <a
                target="_blank"
                style={{ color: '#fff' }}
                rel="noopener noreferrer"
                href="https://www.facebook.com/rentalsugOfficial/"
              >
                <FaFacebookSquare />
              </a>
            </div>
            <div css={footerCss.footerQuickLinks}>
              <a
                target="_blank"
                style={{ color: '#fff' }}
                rel="noopener noreferrer"
                href="https://twitter.com/RentalsUg"
              >
                <FaTwitter />
              </a>
            </div>
            <div css={footerCss.footerQuickLinks}>
              <a
                target="_blank"
                style={{ color: '#fff' }}
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/rentalsug/"
              >
                <FaLinkedin />
              </a>
            </div>
            <div className="">
              <a
                target="_blank"
                style={{ color: '#fff' }}
                rel="noopener noreferrer"
                href="https://www.instagram.com/rentalsug/"
              >
                <FaInstagram />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
);
export default Footer;
